<script setup lang="ts">
import IconLogo from 'assets/logo-full.svg';
</script>

<template>
  <header
    :class="['px-6 pt-[52px] pb-8 max-lg:pt-6 max-lg:pb-1']"
    class="w-full border-b border-gray-300 flex justify-between items-center gap-4"
  >
    <ButtonLevel href="/">
      <IconLogo class="h-[42px] min-w-[242px] cursor-pointer" />
    </ButtonLevel>

    <div class="flex gap-4 w-full justify-between max-lg:hidden">
      <MainMenuPanel />
      <div class="h-[42px] flex items-center gap-4">
        <LanguageSelect />
        <CartButton />
        <AuthBlock />
      </div>
    </div>

    <MobileHeaderMenuPanel />
  </header>
</template>

<style scoped lang="scss">

</style>
